import { render, staticRenderFns } from "./VolunteersView.vue?vue&type=template&id=da6a0d2a&scoped=true"
import script from "./VolunteersView.vue?vue&type=script&lang=js"
export * from "./VolunteersView.vue?vue&type=script&lang=js"
import style0 from "./VolunteersView.vue?vue&type=style&index=0&id=da6a0d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6a0d2a",
  null
  
)

export default component.exports